<template>
  <button
    class="flex w-full items-center justify-between space-x-2 py-3"
    type="button"
  >
    <div class="flex items-center space-x-3">
      <slot name="icon"></slot>
      <div class="flex flex-col items-start space-y-0.5 text-left">
        <h5
          class="text-text-neutral-primary text-base font-semibold"
          data-qa-id="cityList.city"
        >
          {{ name }}
        </h5>
        <p
          class="text-text-neutral-quaternary text-xs"
          data-qa-id="cityList.country"
        >
          {{ country }}
        </p>
      </div>
    </div>
    <p
      class="text-text-neutral-quaternary text-base"
      data-qa-id="cityList.iata"
    >
      {{ iata }}
    </p>
  </button>
</template>

<script setup lang="ts">
  defineProps<{
    name: string;
    country: string;
    iata: string;
  }>();
</script>
